import { createUseStyles } from "react-jss";
import { COLORS } from "./defaults";

export const useCloverStyles = createUseStyles({
  cloverMain: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },

  cloverContainer: {
    position: "relative",
    width: 90,
    height: 90,
    animation: "$spin 2.5s linear infinite",
  },

  leaf: {
    position: "absolute",
    width: 50,
    height: 50,
    background: COLORS.primary.acept,
    borderRadius: "50%",
    transform: "scale(0)",
    animation: "$growAndHide 5s ease infinite",
  },

  center: {
    composes: "$leaf",
    left: 20,
    top: 20,
    background: COLORS.primary.acept,
    animationDelay: "0s",
  },

  top: {
    composes: "$leaf",
    left: 20,
    top: -5,
    animationDelay: "0.2s",
  },

  right: {
    composes: "$leaf",
    right: -5,
    top: 20,
    animationDelay: "0.4s",
  },

  bottom: {
    composes: "$leaf",
    left: 20,
    bottom: -5,
    animationDelay: "0.6s",
  },

  left: {
    composes: "$leaf",
    left: -5,
    top: 20,
    animationDelay: "0.8s",
  },

  /* 🔄 ROTACIÓN */
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },

  /* 🌱 CRECE → SE MANTIENE → SE DESAPARECE */
  "@keyframes growAndHide": {
    "0%": { transform: "scale(0)", opacity: 0 },

    "20%": { transform: "scale(1.2)", opacity: 1 },
    "30%": { transform: "scale(1)", opacity: 1 },

    "60%": { transform: "scale(1)", opacity: 1 },

    /* 🔽 desaparición secuencial */
    "90%": { transform: "scale(0)", opacity: 0 },

    "100%": { transform: "scale(0)", opacity: 0 },
  },
});
